module.exports = __webpack_public_path__ + "img/logo-teb.5e5be7e2.svg";